import React from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  container: { paddingRight: '5%', paddingLeft: '5%' },
  intro: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 50,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 100,
  },
  column: { width: '32%' },
  overviewHeader: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'left',
    display: 'block',
    width: '100%', 
    marginBottom: 20,
  },
  columnCard: {
    width: '32%',
    borderRadius: 6,
    backgroundColor: '#fff',
  },
  textCenter: {
    fontFamily: 'Inter',
    fontSize: 10,
    fontWeight: '400',
    textAlign: 'center',
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgb(226,232,240)',
    borderBottomWidth: '1px',
    paddingTop: 10,
    paddingBottom: 10,
  },
  overviewText: {
    fontFamily: 'Inter',
    fontSize: 10,
    fontWeight: 600,
    textAlign: 'right',
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgb(226,232,240)',
    borderBottomWidth: 1,
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 40,
  },
  detailText: {
    fontFamily: 'Inter',
    textAlign: 'center',
  },
  detailContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    width: '100%',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    paddingRight: 20,
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgb(226,232,240)',
    borderBottomWidth: 0.5,
    height: 70,
  },
  dataText: {
    fontFamily: 'Inter',
    fontWeight: '500',
    textAlign: 'center',
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgb(226,232,240)',
    borderBottomWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 10,
  },
  dataFinal: {
    fontFamily: 'Inter',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: 24,
  }
});

const DataSection = ({ title, value, category, textColor }) => (
  <View style={styles.detailContainer}>
    <Text style={[styles.detailText, { fontSize: 14, fontWeight: '600', color: textColor }]}>{value}</Text>
    {category && (
      <Text style={[styles.detailText, { fontSize: 11, fontWeight: '400', color: textColor }]}>{category}</Text>
    )}
  </View>
);


const OverviewTableDiff = ({ coverData, uiData }) => (
  <View style={styles.container}>
    <View style={styles.intro}>
      <Text style={styles.overviewHeader}>
        {coverData.overview_header}
      </Text>
      {coverData.overview_text.map((item, index) => {
        switch (item.type) {
          case 'paragraph':
            return <Text
              key={index}
              style={{
                display: 'block',
                fontFamily: 'Inter',
                fontSize: 11,
                lineHeight: 1.4,
                marginBottom: 10,
              }}>{item.text}</Text>;
          default:
            return null;
        }
      })}
    </View>

    <View style={styles.row}>
      <View style={styles.column}>
        <Text style={styles.overviewText}>{uiData.profile}</Text>
        <Text style={styles.overviewText}>{uiData.date}</Text>
        <Text style={[styles.overviewText, { height: 70 }]}>{uiData.minimum}</Text>
        <Text style={[styles.overviewText, { height: 70 }]}>{uiData.maximum}</Text>
        <Text style={[styles.overviewText, { lineHeight: '1.7' }]}>{uiData.difference}</Text>
        <Text style={[styles.overviewText, { borderBottomWidth: 0 }]}>{uiData.average}</Text>
      </View>

      {[0, 1].map((index, _, array) => {
        const isLastView = index === array.length - 1;
        const backgroundColor = coverData.avgPoint[1] - coverData.avgPoint[0] >= 0 ? "#7bb662" : "#dc2626";
        const textColor = isLastView ? "#fff" : undefined;

        const viewStyle = isLastView ? { ...styles.columnCard, backgroundColor } : styles.columnCard;

        return (
          <View key={index} style={viewStyle}>
            <Text style={[styles.textCenter, isLastView ? { color: textColor } : {}]}>{coverData.profile[index]}</Text>
            <Text style={[styles.textCenter, isLastView ? { color: textColor } : {}]}>{coverData.date[index]}</Text>
            <DataSection title="Minimum" value={coverData.minimum.points[index]} category={coverData.minimum.category[index]} textColor={isLastView ? textColor : undefined} />
            <DataSection title="Maximum" value={coverData.maximum.points[index]} category={coverData.maximum.category[index]} textColor={isLastView ? textColor : undefined} />
            <Text style={[styles.dataText, { fontSize: 14, fontWeight: '600', color: isLastView ? textColor : undefined }]}>{coverData.diffMaxMin[index]}</Text>
            <Text style={[styles.dataText, { fontSize: 14, fontWeight: '600', borderBottomWidth: 0, color: isLastView ? textColor : undefined }]}>{coverData.avgPoint[index]}</Text>
          </View>
        );
      })}
    </View>
    <View style={[styles.row, { marginTop: 15 }]}>
      <View style={styles.column}>
      </View>
      <View style={styles.column}>
      </View>
      <View style={styles.column}>
        <Text style={[
          styles.dataFinal,
          {
            color: (coverData.avgPoint[1] - coverData.avgPoint[0] >= 0) ? "#7bb662" : "#dc2626"
          }
        ]}>
          {(coverData.avgPoint[1] - coverData.avgPoint[0] >= 0 ? "+" : "") + (coverData.avgPoint[1] - coverData.avgPoint[0])}
        </Text>
      </View>
    </View>
  </View>
);

export default OverviewTableDiff;
